var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__container"},[_c('svg',{staticClass:"loader__spinner",attrs:{"width":"65px","height":"65px","viewBox":"0 0 66 66"}},[_c('circle',{staticClass:"loader__ring",attrs:{"cx":"33","cy":"33","r":"30"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e626d7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/global/loader/loader.pug
// module id = null
// module chunks = 